import { ProductFilters } from "../../../components/filters/models/productFilters";

export interface IProduct {
  machineTypes: string[],
  families: string[],
  platforms: string[],
  subPlatforms: string[],
  plants: string[],
  seriesNames: string[],
  enginePowers: string[],
  usagePeriods: string[],
  engineTypes: string[],
}

export class Product implements IProduct {
  machineTypes: string[] = [];
  families: string[] = [];
  platforms: string[] = [];
  subPlatforms: string[] = [];
  plants: string[] = [];
  seriesNames: string[] = [];
  enginePowers: string[] = [];
  usagePeriods: string[] = [];
  engineTypes: string[] = [];

  constructor(filters?: ProductFilters) {
    if(filters) {
      this.machineTypes = filters.machineTypes;
      this.families = filters.families;
      this.platforms = filters.platforms;
      this.subPlatforms = filters.subPlatforms;
      this.plants = filters.plants;
      this.seriesNames = filters.seriesNames;
      this.enginePowers = filters.enginePowers;
      this.usagePeriods = filters.usagePeriods;
      this.engineTypes = filters.engineTypes;
    }
  }
}
